import { Injectable} from '@angular/core';

Injectable();

export class ModalService {

  abriu = true;

  fecharModal() {
    document.getElementById('geralNP').style.display = 'none';
    this.abriu = false;
    document.getElementById('container').style.display = 'block';
  }

  iniciarModal() {
    if (this.abriu) {
      const htmlElement: HTMLElement =  document.getElementById('geralNP') as HTMLElement;
      htmlElement.style.display = 'block';
      document.getElementById('container').style.display = 'none';
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/publico/ondadoverao/modal-service.service.ts